import axiosService from '@/libs/axiosService'
import { ConfigPayload } from '@/models/SiteConfig'

export const getConfig = (payload: ConfigPayload) => axiosService({
  url: '/config/web',
  method: 'post',
  data: payload
})
